/**
 * This component is currently unused but kept for future implementation.
 * Remove if no longer needed.
 */

"use client";
/* ts-expect-error */
import { solid } from "@areahub/icons";
import { Link } from "@areahub/ui/components/link/link";
import {
  Center,
  Stack,
  StackDirection,
  StackProps,
  Text,
  useColorModeValue as mode,
} from "@chakra-ui/react";
import { ProPlanModal } from "@ui/components/modal/pro-plan/pro-plan-modal";
import { Gcms_GridLayout } from "lib/cms-typings";
import React, { PropsWithChildren, useState } from "react";

const layoutStyles: StackDirection = {
  STACK: "column",
  SPLIT: "row",
};

export interface FeatureIconProps
  extends PropsWithChildren<Partial<any> & StackProps> {}
const FeatureIcon: React.FC<FeatureIconProps> = (props) => {
  const { title, children, icon, layout, ...rest } = props;
  const FIcon = solid[icon as string];
  return (
    <Stack
      direction={layoutStyles[layout as Gcms_GridLayout]}
      w="100%"
      spacing="6"
      _hover={{
        transform: "scale(1.05)",
      }}
      cursor="pointer"
      transition="transform 0.2s"
      {...rest}
    >
      <Center
        aria-hidden
        flexShrink={0}
        w="12"
        h="12"
        rounded="md"
        color="white"
        bg="teal.500"
      >
        <FIcon w="6" h="6" />
      </Center>
      <Stack>
        <Text as="h3" fontSize="xl" fontWeight="extrabold">
          {title}
        </Text>
        <Text
          as="div"
          pr="6"
          color={mode("gray.600", "gray.400")}
          lineHeight="tall"
        >
          {children}
        </Text>
      </Stack>
    </Stack>
  );
};

const FeatureIconWrapper: React.FC<
  FeatureIconProps & {
    index: number;
  }
> = (props) => {
  switch (props.index) {
    case 0:
    case 1:
      const [isOpen, setOpen] = useState(false);
      const onClose = () => setOpen(false);
      return (
        <>
          <FeatureIcon {...props} onClick={() => setOpen(true)} />
          <ProPlanModal {...{ isOpen, onClose }} />
        </>
      );
    case 2:
      return (
        <Link
          href="/individuals/knowledge-center"
          _hover={{ textDecoration: "none" }}
          _focus={{ outline: "none" }}
        >
          <FeatureIcon {...props} />
        </Link>
      );
    default:
      return <FeatureIcon {...props} />;
  }
};

export default FeatureIconWrapper;
